import { action } from 'typesafe-actions';
import { ActionTypes, PresetType, SlidePanelContent, SlidePanelPosition, SlidePanelSide, ViewModeType } from '../types';

export const setRangeAndViewMode = (startDate: Date, endDate: Date, viewModeType: ViewModeType) =>
  action(ActionTypes.SET_RANGE_AND_VIEW_MODE, { startDate, endDate, viewModeType });
export const setRange = (startDate: Date, endDate: Date) => action(ActionTypes.SET_RANGE, { startDate, endDate });
export const setViewMode = (viewModeType: ViewModeType) => action(ActionTypes.SET_VIEW_MODE, { viewModeType });
export const setPreset = (preset: PresetType) => action(ActionTypes.SET_PRESET, { preset });
export const setParentMediaId = (parentMediaId: number) => action(ActionTypes.SET_PARENT_MEDIA_ID, { parentMediaId });
export const setSelectedMediaId = (mediaId: number) => action(ActionTypes.SET_SELECTED_MEDIA_ID, { mediaId });
export const setSlidePanelPositionAndContent = (
  slidePanelPosition: SlidePanelPosition,
  slidePanelContent: SlidePanelContent,
  slidePanelSide: SlidePanelSide
) =>
  action(ActionTypes.SET_SLIDE_PANEL_POSITION_AND_CONTENT, { slidePanelPosition, slidePanelContent, slidePanelSide });



// WEBPACK FOOTER //
// ./src/store/actions/timelineActions.ts